// @ts-ignore
import { apiGetV3 } from '../utils/api'
import { ITaxTypeDTO, ITaxTypesResponse } from 'types/taxes'

export const getTaxTypesAPI = (): Promise<ITaxTypeDTO> => {
  return apiGetV3('mgmt/taxes/tax-types').then((res: ITaxTypesResponse) => res.data)
}



// WEBPACK FOOTER //
// ./src/api/taxType.ts